import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { Icon } from '@/components'
import { IconName } from '@/assets/icons'

type NavigationPageRowProps = {
  href: string
  title: string
  isActive: boolean
  iconName: IconName
}

export const NavigationPageRow: FC<NavigationPageRowProps> = ({ href, iconName, title, isActive }) => {
  return (
    <Link to={href} style={{ textDecoration: 'none' }}>
      <Box
        sx={{
          bgcolor: isActive ? 'linkPage.active' : 'linkPage.notActive',
          padding: '8px 16px',
          flexDirection: 'row',
          justifyContent: 'start',
          alignItems: 'center',
          display: 'flex',
          borderRadius: '8px',
          width: '100%',
          height: '40px',
          gap: '4px',
          transition: '0.5s',
          color: isActive ? 'linkPageText.active' : 'linkPageText.notActive',
          '&:hover': {
            color: 'linkPageText.active',
          },
        }}
      >
        <Icon name={iconName} size={'lg'} colorScheme={'currentColor'} />
        <Typography variant="subtitle2" color={'inherit'}>
          {title}
        </Typography>
      </Box>
    </Link>
  )
}
